import { httpGet } from '@pressreader/services';

import { ITrialEligibilityDto, NotEligibleReasonDto } from './types/eligibility.dto';

function loadTrialEligibility(): Promise<ITrialEligibilityDto> {
    return httpGet<ITrialEligibilityDto>('subscriptions', 'trial/eligibility').then(
        result => result,
        () => ({ isEligible: false, notEligibleReason: NotEligibleReasonDto.None, promoCode: '' }),
    );
}

export { loadTrialEligibility };
